import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { i18n } from 'config/locales';

import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';

import { rootSelectors } from '@redux/modules/selectors';
import { isPVQForm } from 'helpers/form';
import Intro from './Intro';
import ConnectedCompetence from './Competence/Competence';
import ConnectedConsultation from './Consultation/Consultation';
import ConnectedHospitalizations from './Hospitalizations/Hospitalizations';
import ConnectedDiagnoses from './Diagnoses/Diagnoses';
import ConnectedExistingConditions from './ExistingConditions/ExistingConditions';
import Review from './Review';
import SectionNotFound from '../shared/SectionNotFound';

const Psychological = function (props) {
  const { subsection, location, isReview } = props;

  const subsectionClasses = classnames('view', `view-${subsection.name}`);

  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="section-view">
      {title && <h1 className="title">{title}</h1>}
      {para}

      <div className={subsectionClasses}>
        {isReview && (
          <div className="top-btns">
            <ErrorList />
          </div>
        )}
        <Switch>
          <Route path="/form/psychological/intro" render={() => <Intro {...props} />} />
          <Route path="/form/psychological/competence" component={ConnectedCompetence} />
          <Route path="/form/psychological/consultations" component={ConnectedConsultation} />
          <Route
            path="/form/psychological/hospitalizations"
            component={ConnectedHospitalizations}
          />
          <Route path="/form/psychological/diagnoses" component={ConnectedDiagnoses} />
          <Route path="/form/psychological/conditions" component={ConnectedExistingConditions} />
          <Route path="/form/psychological/review" component={Review} />
          <Route component={SectionNotFound} />
        </Switch>
        <SectionNavigation currentPath={location.pathname} />
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
});

Psychological.propTypes = {
  subsection: PropTypes.object,
  location: PropTypes.object,
  isReview: PropTypes.bool,
  formType: PropTypes.string,
};

Psychological.defaultProps = {
  subsection: {},
  location: {},
  formType: '',
};

export default connect(mapStateToProps)(Psychological);

export var PsychologicalSections = function () {
  return <Review />;
};
